import { render } from "./MailPermissionComplete.vue?vue&type=template&id=72bc78d9&ts=true"
import script from "./MailPermissionComplete.vue?vue&type=script&lang=ts"
export * from "./MailPermissionComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__